import React from 'react'
import { Link } from 'react-router-dom'
import { Row, Button } from 'react-bootstrap'

const Message = (props) => {

  const { name, message, route, type, is_pinned } = props.notification

  return (
    <div id="NotificationMessage">
      <Row style={ { paddingLeft:'15px' } }>
        <p style={ { display: "inline-block" } }>
          { name }
        </p>
        { is_pinned ?
          <Button
            style={ { float: "right", display: "inline-block" } }
            bsStyle="primary"
            onClick={ () => props.unpinNotification(props.notification) }
          >
            Unpin
          </Button>
          :
          <Button
            style={ { float: "right", display: "inline-block" } }
            bsStyle="default"
            onClick={ () => props.pinNotification(props.notification) }
          >
            Pin
          </Button>
        }
      </Row>
      <div dangerouslySetInnerHTML={ { __html: message } }/>
      <Row style={ { paddingLeft:'15px' } }>
        <Link to={ `${type}/${route}` }>
          {type === 'proposals' ?
            'Go to related Proposal'
            :
            'Go to related Project'
          }
        </Link>
      </Row>
    </div>
  )
}

export default Message



// WEBPACK FOOTER //
// ./src/routes/notifications/components/Message.js